export default {
  view: {
    component: () =>
      import(
        /* webpackChunkName: "archive_detail" */ "@/mods/archive/outApply/detailView/OutApplyView"
      ),
  },
};
